import React, { useState } from "react";
// import { ErrorMessage, Form, input, Formik } from "formik";
import axios from "axios";
import { AiOutlineEye, AiOutlineEyeInvisible } from "react-icons/ai";
import { useNavigate, useSearchParams } from "react-router-dom";
import Loader from "../Components/Global/Loader";
import DashboardLayouts from "../Components/Layout/DashboardLayouts";

function Resetpassword() {
  const [searchParams, setSearchParams] = useSearchParams();
  const [errorMessage, setErrorMessage] = useState();
  const route = useNavigate();
  // const resetId = atob(searchParams.get("id"));

  // get params id from url 
  const resetId = searchParams.get("id")

  const [loading, setLoading] = useState(false);
  const [resetPasswordData, setResetPasswordData] = useState({

    new_password: "",
    new_password_type: "password",
    confirm_password: "",
    confirm_password_type: "password"

  });
  const { old_password, new_password, confirm_password, confirm_password_type, new_password_type } = resetPasswordData;


  // Validation from inputs

  const validation = () => {
    const errors = {};
 

    if (!new_password.trim()) {
      errors.new_password = "Please enter your new password.";
    } else if (new_password.trim().length < 8) {
      errors.new_password = "Please enter at least 8 characters.";
    }

    if (!confirm_password.trim()) {
      errors.confirm_password = "Please enter confirmation password.";
    } else if (confirm_password.trim().length < 8) {
      errors.confirm_password = "Please enter at least 8 characters.";
    } else if (confirm_password.trim() !== new_password.trim()) {
      errors.confirm_password = "Confirmation password do not match.";
    }

    return errors;
  };



  // handle data to state update 

  const handleData = (e) => {
    const { value } = e.target;
    setResetPasswordData({ ...resetPasswordData, [e.target.name]: value });
    setErrorMessage();
  };


  //Api call to reset password
  const ResetPasswordFunc = (e) => {
    e.preventDefault();
    setErrorMessage();
    const Valid = validation();
    setErrorMessage(Valid);

    if (Object.keys(Valid)?.length == 0) {
      setLoading(true);

      var data1 = resetPasswordData;
      data1 = {
        reset_password: confirm_password,
        id: resetId,
      };


      if (resetId) {
        axios
          .post("/forgotpassword", data1)
          .then(function (response) {
            if (response.status === 200) {
              setLoading(false);
              route("/");
            } else if (response.status === 201) {
              setLoading(false);
              // setBackendmsg(response.data.errMsg);
            } else if (response.status === 401) {
              setErrorMessage(response);
              setLoading(false);
            }
          })
          .catch((error) => {
            setLoading(false);
            setErrorMessage({ backendError: error?.response?.data });
          });
      }
    } else {
      setErrorMessage(Valid);
    }
  };

  return (
    <>
      {loading && <Loader />}
      <DashboardLayouts>
        <div className="login_form custom__form-a">
          <form className="form-area">
            <h1 className="mb-xl-5 mb-lg-4 mb-md-3 text-center">
              Reset Password
            </h1>
            <div className="row gy-4">
             
              <div className="form-group">
                <label htmlFor="" className="form-lbl">
                  New Password
                </label>
                <div className="position-relative">
                  <input
                    type={new_password_type}
                    name="new_password"
                    value={new_password}
                    onChange={(e) => handleData(e)}
                    className="form-control form-g1"
                    placeholder={`create password`}
                  />
                  <div className="position-absolute top-50 start-100 translate-middle pe-5" onClick={() => { setResetPasswordData({ ...resetPasswordData, new_password_type: new_password_type == "text" ? "password" : "text" }) }}>
                    {new_password_type == "text" ? <AiOutlineEye /> : <AiOutlineEyeInvisible />}
                  </div>
                </div>
                {errorMessage?.new_password ? (
                  <div className="error error-message" style={{ color: "red" }}>
                    {errorMessage?.new_password}
                  </div>
                ) : (
                  ""
                )}
              </div>
              <div className="form-group">
                <label htmlFor="" className="form-lbl">
                  Confirm Password
                </label>
                <div className="position-relative">
                  <input
                    type={confirm_password_type}
                    name="confirm_password"
                    value={confirm_password}
                    onChange={(e) => handleData(e)}
                    className="form-control form-g1"
                    placeholder={`confirm your password`}
                  />
                  <div className="position-absolute top-50 start-100 translate-middle pe-5" onClick={() => { setResetPasswordData({ ...resetPasswordData, confirm_password_type: confirm_password_type == "text" ? "password" : "text" }) }}>
                    {confirm_password_type == "text" ? <AiOutlineEye /> : <AiOutlineEyeInvisible />}
                  </div>
                </div>
                {errorMessage?.confirm_password ? (
                  <div className="error error-message" style={{ color: "red" }}>
                    {errorMessage?.confirm_password}
                  </div>
                ) : (
                  ""
                )}
              </div>
              <div className="my-3">
                <button
                  type="submit"
                  className="btn btn-primary btn-lg login-btn w-100"
                  onClick={(e) => ResetPasswordFunc(e)}
                >
                  Change Password
                </button>
              </div>
            </div>
          </form>
        </div>

        {errorMessage?.backendError && (
          <div className="col-xl-12 mt-2 ">
            <b className=" text-m bg-red-50 block text-center p-4 rounded border border-danger text-danger">
              {errorMessage?.backendError}
            </b>
          </div>
        )}
      </DashboardLayouts>
    </>
  );
}

export default Resetpassword;
